import React from 'react';

interface SocialIconLinkProps {
  href: string;
  label: string;
  icon: React.ReactNode;
}

export const SocialIconLink: React.FC<SocialIconLinkProps> = ({ href, label, icon }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="w-10 h-10 !text-[#FFFCF5] hover:text-[#C3B89F] transition-colors"
      aria-label={label}
    >
      {icon}
    </a>
  );
};
